// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"TableContainer_scrollContainer__hbup2","scrollContainer--isOverflowHidden":"TableContainer_scrollContainer--isOverflowHidden__3blZV"};